import View from "../framework/view";
import template from "../../pugc/inventory";
import Server from "../server";
import {Product} from "../bo/product";
import jQuery from "jquery";
import {Inventory} from "../bo/inventory";
import {AddOrderView} from "./add_order";
import {formToJson, plural} from "../misc/utils";
import Alerts from "../misc/alerts";

const classname = "inventory-view";

const server = Server.instance();

export class InventoryView extends View {

    private inventory: Inventory[] = [];

    private general : string[] = [];

    private products: Product[] = [];

    private usage: any = {};

    private loaded = false;

    private expand_used_by : any = {};

    constructor() {
        super(classname);
        this.init();
    }

    async init() {
        this.loaded = false;
        this.general = await server.getGeneralInventory();
        this.products = await server.getProducts();
        this.inventory = await server.getInventory();

        const usage : any = {};
        this.general.forEach(name => usage[name] = []);

        for (const prod of this.products) {
            for (const opt of (prod.productOptions || [])) {
                for (const choice of (opt.choices || [])) {
                    for (const use of (choice.uses || [])) {
                        const name = use.name as string;
                        usage[name] = usage[name] || [];
                        usage[name].push({
                            product_name: prod.name,
                            choice: choice.description,
                            qty: use.quantity
                        });
                    }
                }
            }
        }
        this.usage = usage;
        this.loaded = true;

        this.update();
    }

    render0() {

        const renderPickupDelivery = (inv: Inventory) => {
            if (inv.forDelivery && inv.forPickup) {
                return "Both";
            } else if (inv.forDelivery) {
                return "Delivery";
            } else if (inv.forPickup) {
                return "Pickup";
            } else {
                return "";
            }
        }

        const data = {
            general: this.general,
            usage: this.usage,
            inventory: this.inventory,
            loaded: this.loaded,
            renderPickupDelivery: renderPickupDelivery,
            plural: plural,
            expand_used_by: this.expand_used_by,
        };

        const out = this.pug(template, data);

        this.afterUpdate(() => {
            this.elt().find("input.datefield").datefield({startDay: 1});
        });

        return out;
    }

    public async refresh() {
        server.clearCache();
        await this.init();
    }

    async addAvailable(idx: number, qty: number) {
        const inv = this.inventory[idx];
        inv.quantity = Number(inv.quantity) + qty;
        await server.addInventory(inv);
        this.init();
    }

    async setAlarm(idx: number, qty: number | undefined) {
        const inv = this.inventory[idx];
        delete inv.quantity;
        inv.alarm = qty;
        await server.addInventory(inv);
        this.init();
    }

    async setOutOfStockMsg(idx: number, n: string) {
        const inv = this.inventory[idx];
        delete inv.quantity;
        inv.out_of_stock_msg = n;
        await server.addInventory(inv);
        this.init();
    }

    async deletePrimary(idx: number) {
        const inv = this.inventory[idx];
        await server.deletePrimaryInventory(inv);
        this.init();
    }


    async setActive(idx: number, n: boolean) {
        const inv = this.inventory[idx];
        delete inv.quantity;
        inv.active = n;
        await server.addInventory(inv);
        this.init();
    }

    async addNewDates() {
        const elt = this.elt();
        const data: any = {};
        const form = elt.find(".add-new-form").find("input, select");
        formToJson(form, data);

        const forDelivery = data.pickupDelivery == "Both" || data.pickupDelivery == "Delivery";
        const forPickup = data.pickupDelivery == "Both" || data.pickupDelivery == "Pickup";

        if (! data.fromDate) {
            Alerts.alert("You must specify a 'from' date");
            return;
        }

        await server.addInventory({
            name: data.name,
            quantity: 0,
            fromDate: data.fromDate ,
            toDate: data.toDate,
            forDelivery: forDelivery,
            forPickup: forPickup,
        });

        this.init();
    }

    async addNewInventoryType() {
        const name = this.elt().find("input[name='inventory_type']").val() as string;
        await server.addInventory({
            name: name
        });
        this.init();
    }

    async deleteInv(inv: string) {
        await server.deleteInventory(inv);
        this.init();
    }

    expandUsedBy(inv: string, expand: boolean) {
        this.expand_used_by[inv] = expand;
        this.update(".product_usage");
    }
}

View.on(
    "." + classname,
    "click",
    ".add-available",
    function(that: InventoryView, event, elt) {
        event.preventDefault();
        const idx = jQuery(elt).closest(".inv").data("idx") as number;
        const qty = +(jQuery(elt).closest(".inv").find("input[name='qty']").val() as string);
        that.addAvailable(idx, qty);
    });

View.on(
    "." + classname,
    "change",
    "input[name=alarm]",
    function(that: InventoryView, event, elt) {
        event.preventDefault();
        const idx = jQuery(elt).closest(".inv").data("idx") as number;
        const qty0 = jQuery(elt).val() as string;
        const qty = qty0 !== "" ? Number(qty0) : undefined;
        that.setAlarm(idx, qty);
    });

View.on(
    "." + classname,
    "change",
    "input[name=out_of_stock_msg]",
    function(that: InventoryView, event, elt) {
        event.preventDefault();
        const idx = jQuery(elt).closest(".inv").data("idx") as number;
        const n = jQuery(elt).val() as string;
        that.setOutOfStockMsg(idx, n);
    });

View.on(
    "." + classname,
    "click",
    "button.delete-primary",
    function(that: InventoryView, event, elt) {
        event.preventDefault();
        const idx = jQuery(elt).closest(".inv").data("idx") as number;
        that.deletePrimary(idx);
    });


View.on(
    "." + classname,
    "change",
    "select[name=active]",
    function(that: InventoryView, event, elt) {
        event.preventDefault();
        const idx = jQuery(elt).closest(".inv").data("idx") as number;
        const val = jQuery(elt).val();
        const n = val === "1" ? true : false;
        that.setActive(idx, n);
    });

View.on(
    "." + classname,
    "click",
    "button.add-new-dates",
    function(that: InventoryView, event, elt) {
        event.preventDefault();
        that.addNewDates();
    });

View.on(
    "." + classname,
    "click",
    "button.add-new-inventory-type",
    function(that: InventoryView, event, elt) {
        event.preventDefault();
        that.addNewInventoryType();
    });

View.on(
    "." + classname,
    "click",
    ".general-inventory a.delete",
    function(that: InventoryView, event, elt) {
        event.preventDefault();
        const inv = jQuery(elt).data("inv") as string;
        that.deleteInv(inv);
    });

View.on(
    "." + classname,
    "click",
    ".used_by_expand",
    function(that: InventoryView, event, elt) {
        event.preventDefault();
        const inv = jQuery(elt).data("inv") as string;
        const expand = jQuery(elt).data("expand") ? true : false;
        that.expandUsedBy(inv, expand);
    });

